import * as THREE from 'three'

export default function createEnvironment({ scene, rgbeLoader, hdrUrl })
{
  rgbeLoader.load(hdrUrl, (environmentMap) =>
  {
    environmentMap.mapping = THREE.EquirectangularReflectionMapping
    scene.background = environmentMap
    scene.environment = environmentMap
  })
}
